// AUTO-GENERATED by tools/generate-help.ts — DO NOT EDIT BY HAND.
// Structure comes from shared/src/help/articles.ts; prose is snapshotted from
// server/src/internal/i18n/catalogs/app.{en,es,pt}.properties.
// Regenerate with: npm run gen:help
import type { HelpArticle, HelpLocale } from './helpTypes';

export const HELP_INDEX_INTRO_KEY = "help.index.intro";

export const HELP_CONTACT_KEYS = {
  "title": "help.contact.title",
  "subtitle": "help.contact.subtitle",
  "cta": "help.contact.cta"
} as const;

export const HELP_ABOUT = {
  "titleKey": "help.about.title",
  "bodyKey": "help.about.body",
  "pillars": [
    {
      "id": "alarms",
      "titleKey": "help.about.alarms_title",
      "descKey": "help.about.alarms_desc"
    },
    {
      "id": "practice",
      "titleKey": "help.about.practice_title",
      "descKey": "help.about.practice_desc"
    },
    {
      "id": "reviews",
      "titleKey": "help.about.reviews_title",
      "descKey": "help.about.reviews_desc"
    },
    {
      "id": "daily",
      "titleKey": "help.about.daily_title",
      "descKey": "help.about.daily_desc"
    }
  ]
} as const;

export const HELP_ARTICLES: HelpArticle[] = [
  {
    "id": "analysis-alarms",
    "icon": "notifications-outline",
    "titleKey": "help.alarms.title",
    "teaserKey": "help.alarms.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.alarms.p1"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p2"
      },
      {
        "type": "heading",
        "key": "help.alarms.h_alarm"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p3"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p4"
      },
      {
        "type": "bullets",
        "keys": [
          "help.alarms.b_categories",
          "help.alarms.b_lookback",
          "help.alarms.b_timepressure"
        ]
      },
      {
        "type": "tip",
        "key": "help.alarms.tip_wizard",
        "icon": "alert-circle-outline"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p5"
      },
      {
        "type": "heading",
        "key": "help.alarms.h_session"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p6"
      },
      {
        "type": "bullets",
        "keys": [
          "help.alarms.b_email",
          "help.alarms.b_push",
          "help.alarms.b_freecap"
        ]
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p7"
      },
      {
        "type": "heading",
        "key": "help.alarms.h_practice"
      },
      {
        "type": "paragraph",
        "key": "help.alarms.p8"
      },
      {
        "type": "cta",
        "key": "help.alarms.cta_settings",
        "target": {
          "kind": "settings"
        },
        "icon": "options-outline"
      }
    ]
  },
  {
    "id": "opening-notifications",
    "icon": "megaphone-outline",
    "titleKey": "help.notifications.title",
    "teaserKey": "help.notifications.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.notifications.p1"
      },
      {
        "type": "heading",
        "key": "help.notifications.h_why"
      },
      {
        "type": "paragraph",
        "key": "help.notifications.p_why"
      },
      {
        "type": "bullets",
        "keys": [
          "help.notifications.b_pointslost",
          "help.notifications.b_recent",
          "help.notifications.b_godeeper"
        ]
      },
      {
        "type": "heading",
        "key": "help.notifications.h_review"
      },
      {
        "type": "paragraph",
        "key": "help.notifications.p_review"
      },
      {
        "type": "heading",
        "key": "help.notifications.h_actions"
      },
      {
        "type": "bullets",
        "keys": [
          "help.notifications.b_accept",
          "help.notifications.b_skip"
        ]
      },
      {
        "type": "tip",
        "key": "help.notifications.tip_30days",
        "icon": "time-outline"
      }
    ]
  },
  {
    "id": "practices",
    "icon": "school-outline",
    "titleKey": "help.practices.title",
    "teaserKey": "help.practices.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.practices.p1"
      },
      {
        "type": "heading",
        "key": "help.practices.h_yourgames"
      },
      {
        "type": "bullets",
        "keys": [
          "help.practices.b_engine_mistakes",
          "help.practices.b_streak",
          "help.practices.b_rush",
          "help.practices.b_engine_rush",
          "help.practices.b_guess_eval",
          "help.practices.b_move_verdict",
          "help.practices.b_worst_move",
          "help.practices.b_good_decision",
          "help.practices.b_worst_piece",
          "help.practices.b_favorites"
        ]
      },
      {
        "type": "heading",
        "key": "help.practices.h_notyours"
      },
      {
        "type": "paragraph",
        "key": "help.practices.p2"
      },
      {
        "type": "paragraph",
        "key": "help.practices.p3"
      },
      {
        "type": "heading",
        "key": "help.practices.h_daily"
      },
      {
        "type": "paragraph",
        "key": "help.practices.p4"
      },
      {
        "type": "bullets",
        "keys": [
          "help.practices.b_daily_size",
          "help.practices.b_daily_mix",
          "help.practices.b_daily_anchor",
          "help.practices.b_daily_alarm"
        ]
      },
      {
        "type": "paragraph",
        "key": "help.practices.p5"
      },
      {
        "type": "cta",
        "key": "help.practices.cta_daily",
        "target": {
          "kind": "daily-training"
        },
        "icon": "calendar-outline"
      },
      {
        "type": "cta",
        "key": "help.practices.cta_practice",
        "target": {
          "kind": "practice"
        },
        "icon": "school-outline"
      }
    ]
  },
  {
    "id": "game-review",
    "icon": "analytics-outline",
    "titleKey": "help.review.title",
    "teaserKey": "help.review.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.review.p1"
      },
      {
        "type": "heading",
        "key": "help.review.h_engine"
      },
      {
        "type": "bullets",
        "keys": [
          "help.review.b_categories",
          "help.review.b_arrows",
          "help.review.b_evalbar",
          "help.review.b_precision"
        ]
      },
      {
        "type": "heading",
        "key": "help.review.h_coach"
      },
      {
        "type": "paragraph",
        "key": "help.review.p2"
      },
      {
        "type": "paragraph",
        "key": "help.review.p3"
      },
      {
        "type": "heading",
        "key": "help.review.h_strategic"
      },
      {
        "type": "paragraph",
        "key": "help.review.p4"
      },
      {
        "type": "tip",
        "key": "help.review.tip_squares",
        "icon": "hand-left-outline"
      },
      {
        "type": "heading",
        "key": "help.review.h_askai"
      },
      {
        "type": "paragraph",
        "key": "help.review.p5"
      },
      {
        "type": "bullets",
        "keys": [
          "help.review.b_askai_when",
          "help.review.b_askai_anchor",
          "help.review.b_askai_limit"
        ]
      },
      {
        "type": "heading",
        "key": "help.review.h_favorites"
      },
      {
        "type": "paragraph",
        "key": "help.review.p6"
      },
      {
        "type": "tip",
        "key": "help.review.tip_longpress_star",
        "icon": "star-outline"
      },
      {
        "type": "heading",
        "key": "help.review.h_gestures"
      },
      {
        "type": "bullets",
        "keys": [
          "help.review.b_g_longpress_piece",
          "help.review.b_g_tap_piece",
          "help.review.b_g_swipe_panels",
          "help.review.b_g_swipe_games",
          "help.review.b_g_swipe_down",
          "help.review.b_g_longpress_arrows",
          "help.review.b_g_clock"
        ]
      },
      {
        "type": "cta",
        "key": "help.review.cta_games",
        "target": {
          "kind": "games"
        },
        "icon": "grid-outline"
      }
    ]
  },
  {
    "id": "analytics",
    "icon": "stats-chart-outline",
    "titleKey": "help.analytics.title",
    "teaserKey": "help.analytics.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.analytics.p1"
      },
      {
        "type": "heading",
        "key": "help.analytics.h_strategic"
      },
      {
        "type": "paragraph",
        "key": "help.analytics.p2"
      },
      {
        "type": "paragraph",
        "key": "help.analytics.p3"
      },
      {
        "type": "paragraph",
        "key": "help.analytics.p4"
      },
      {
        "type": "bullets",
        "keys": [
          "help.analytics.b_m_pawn",
          "help.analytics.b_m_exchange",
          "help.analytics.b_m_tempos",
          "help.analytics.b_m_streak",
          "help.analytics.b_m_acpl",
          "help.analytics.b_m_longthink",
          "help.analytics.b_m_forced",
          "help.analytics.b_m_ontime",
          "help.analytics.b_m_ontime_winning",
          "help.analytics.b_m_slipped",
          "help.analytics.b_m_comeback",
          "help.analytics.b_m_wontime_lost"
        ]
      },
      {
        "type": "heading",
        "key": "help.analytics.h_progress"
      },
      {
        "type": "paragraph",
        "key": "help.analytics.p5"
      },
      {
        "type": "bullets",
        "keys": [
          "help.analytics.b_p_rating",
          "help.analytics.b_p_precision",
          "help.analytics.b_p_winshare",
          "help.analytics.b_p_equal",
          "help.analytics.b_p_time"
        ]
      },
      {
        "type": "paragraph",
        "key": "help.analytics.p6"
      },
      {
        "type": "heading",
        "key": "help.analytics.h_glossary"
      },
      {
        "type": "glossary",
        "entries": [
          {
            "termKey": "help.analytics.g_cp_term",
            "definitionKey": "help.analytics.g_cp_def"
          },
          {
            "termKey": "help.analytics.g_acpl_term",
            "definitionKey": "help.analytics.g_acpl_def"
          },
          {
            "termKey": "help.analytics.g_precision_term",
            "definitionKey": "help.analytics.g_precision_def"
          },
          {
            "termKey": "help.analytics.g_fen_term",
            "definitionKey": "help.analytics.g_fen_def"
          },
          {
            "termKey": "help.analytics.g_pgn_term",
            "definitionKey": "help.analytics.g_pgn_def"
          },
          {
            "termKey": "help.analytics.g_streak_term",
            "definitionKey": "help.analytics.g_streak_def"
          }
        ]
      },
      {
        "type": "cta",
        "key": "help.analytics.cta_analytics",
        "target": {
          "kind": "analytics"
        },
        "icon": "stats-chart-outline"
      }
    ]
  },
  {
    "id": "openings-analytics",
    "icon": "trending-up-outline",
    "titleKey": "help.openings.title",
    "teaserKey": "help.openings.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.openings.p1"
      },
      {
        "type": "heading",
        "key": "help.openings.h_favorites"
      },
      {
        "type": "paragraph",
        "key": "help.openings.p2"
      },
      {
        "type": "heading",
        "key": "help.openings.h_metrics"
      },
      {
        "type": "paragraph",
        "key": "help.openings.p3"
      },
      {
        "type": "bullets",
        "keys": [
          "help.openings.b_streak",
          "help.openings.b_offbook",
          "help.openings.b_reoccurrence",
          "help.openings.b_cleandepth",
          "help.openings.b_firstslow"
        ]
      },
      {
        "type": "tip",
        "key": "help.openings.tip_threshold",
        "icon": "time-outline"
      },
      {
        "type": "heading",
        "key": "help.openings.h_regressions"
      },
      {
        "type": "paragraph",
        "key": "help.openings.p4"
      },
      {
        "type": "heading",
        "key": "help.openings.h_recs"
      },
      {
        "type": "paragraph",
        "key": "help.openings.p5"
      },
      {
        "type": "cta",
        "key": "help.openings.cta_analytics",
        "target": {
          "kind": "openings-analytics"
        },
        "icon": "trending-up-outline"
      },
      {
        "type": "cta",
        "key": "help.openings.cta_settings",
        "target": {
          "kind": "settings"
        },
        "icon": "options-outline"
      }
    ]
  },
  {
    "id": "subscription",
    "icon": "diamond-outline",
    "titleKey": "help.plans.title",
    "teaserKey": "help.plans.teaser",
    "blocks": [
      {
        "type": "paragraph",
        "key": "help.plans.p1"
      },
      {
        "type": "heading",
        "key": "help.plans.h_free"
      },
      {
        "type": "bullets",
        "keys": [
          "help.plans.free_sites",
          "help.plans.free_history",
          "help.plans.free_lookback",
          "help.plans.free_alarms",
          "help.plans.free_askai",
          "help.plans.free_puzzles"
        ]
      },
      {
        "type": "heading",
        "key": "help.plans.h_pro"
      },
      {
        "type": "bullets",
        "keys": [
          "help.plans.pro_sites",
          "help.plans.pro_history",
          "help.plans.pro_lookback",
          "help.plans.pro_alarms",
          "help.plans.pro_askai",
          "help.plans.pro_puzzles",
          "help.plans.pro_finetune"
        ]
      },
      {
        "type": "tip",
        "key": "help.plans.tip_data",
        "icon": "shield-checkmark-outline"
      },
      {
        "type": "cta",
        "key": "help.plans.cta_subscription",
        "target": {
          "kind": "subscription"
        },
        "icon": "diamond-outline"
      }
    ]
  }
];

export const HELP_PROSE: Record<HelpLocale, Record<string, string>> = {
  "en": {
    "help.about.alarms_desc": "A heads-up when you slip up, so you can learn while the game is fresh.",
    "help.about.alarms_title": "Mistake alarms",
    "help.about.body": "ChessWiz helps casual players get better — using the games you already play. Link your Chess.com or Lichess account, and it learns from your real mistakes to build training made just for you.",
    "help.about.daily_desc": "A short daily set from your games, plus the positions you saved to revisit.",
    "help.about.daily_title": "Daily training & favorites",
    "help.about.practice_desc": "Puzzles built from your own games and your weak spots.",
    "help.about.practice_title": "Practice made for you",
    "help.about.reviews_desc": "Every game reviewed for you — no setup needed.",
    "help.about.reviews_title": "Automatic game reviews",
    "help.about.title": "What ChessWiz does",
    "help.alarms.b_categories": "The move categories you care about — brilliant moves, early mistakes, mistakes played after a long think, missed forced mates, and blunders.",
    "help.alarms.b_email": "Email: alarms in the same session continue the same conversation instead of starting a new one, so your inbox keeps one running thread per kind of alarm rather than one message per move.",
    "help.alarms.b_freecap": "Alarms are unlimited on every plan, including Free — every session that matches your criteria reaches you.",
    "help.alarms.b_lookback": "How far back we look for matching moves.",
    "help.alarms.b_push": "Push: you are notified once, at the start of a session. Later alarms in that same session are added quietly, without a second buzz.",
    "help.alarms.b_timepressure": "Whether moves played under time pressure are excluded. They are, by default.",
    "help.alarms.cta_settings": "Open your practice criteria",
    "help.alarms.h_alarm": "What counts as an alarm",
    "help.alarms.h_practice": "The same criteria power your practice",
    "help.alarms.h_session": "The 30-minute session",
    "help.alarms.p1": "When you link a Chess.com or Lichess account, ChessWiz imports your games and analyzes them on our servers. This is not a one-off: for as long as the account stays linked, we keep looking for new games and analyzing them automatically. You never have to upload anything by hand.",
    "help.alarms.p2": "New games are picked up roughly once an hour per linked account, and analysis runs in the background — so a game usually becomes reviewable a few minutes after you finish playing it.",
    "help.alarms.p3": "Once a game is analyzed, every move you played is compared against your practice criteria. A move that matches is called an alarm, and we send it to you by email and push notification.",
    "help.alarms.p4": "Your criteria decide everything about which moves reach you:",
    "help.alarms.p5": "On Pro you can also fine-tune the criteria: a move-number range, a minimum number of points lost, how long you spent on the move, which time controls count, and whether a repeated mistake always notifies you.",
    "help.alarms.p6": "Alarms are grouped into sessions. A session stays open for 30 minutes, and each new alarm extends it by another 30 minutes.",
    "help.alarms.p7": "This is why a long session of games rarely turns into a burst of notifications.",
    "help.alarms.p8": "Engine Mistakes practice is built from exactly the same criteria as your alarms. Widening your categories or your lookback window gives you both more notifications and a bigger practice queue; narrowing them makes both more selective.",
    "help.alarms.teaser": "How your games get analyzed automatically, and when we notify you.",
    "help.alarms.tip_wizard": "If you have never finished the practice criteria wizard, no alarms are generated at all. Completing it once switches them on.",
    "help.alarms.title": "Analysis, linked accounts and alarms",
    "help.analytics.b_m_acpl": "Average CP lost — see the glossary below. Lower is better.",
    "help.analytics.b_m_comeback": "Comeback wins — games you won after being at −3 or worse.",
    "help.analytics.b_m_exchange": "Exchange mistakes — trades that left your position worse.",
    "help.analytics.b_m_forced": "Forced difficult opponent reply — how often your move left your opponent only one narrow answer.",
    "help.analytics.b_m_longthink": "Long think with many good options — how often you burned time in positions where several moves were fine.",
    "help.analytics.b_m_ontime": "Percentage of games lost on time.",
    "help.analytics.b_m_ontime_winning": "Lost on time while winning — timeouts where you were still clearly better.",
    "help.analytics.b_m_pawn": "Pawn structure mistakes — strategic errors involving weak pawn structure.",
    "help.analytics.b_m_slipped": "Games with a +3 advantage slipped — winning positions that ended in a loss.",
    "help.analytics.b_m_streak": "Longest move streak — your longest run of book, brilliant, great or best moves.",
    "help.analytics.b_m_tempos": "Average tempi lost per game, from inefficient development and move order.",
    "help.analytics.b_m_wontime_lost": "Won on time while completely lost — the mirror image, for honesty's sake.",
    "help.analytics.b_p_equal": "Equal or better until — the move number up to which you were still not losing, taken as the middle value across the week. This is the one that shows whether your openings are holding up.",
    "help.analytics.b_p_precision": "Precision — how close your moves were to the engine's, averaged across the week's games. See the glossary.",
    "help.analytics.b_p_rating": "Rating — your rating at the end of each week. The blunt measure, and the noisiest one.",
    "help.analytics.b_p_time": "Time superior games — the share of games where you kept more time on the clock than your opponent for most of the game.",
    "help.analytics.b_p_winshare": "Winning share — the percentage of your own moves after which you stood at least a third of a pawn better. It measures how much of your games you spend on top, rather than how they ended.",
    "help.analytics.cta_analytics": "Open analytics",
    "help.analytics.g_acpl_def": "For each of your moves, how many centipawns the move gave away compared with the best move — then averaged over all your moves. Good moves count as zero rather than cancelling out mistakes, so the number only ever measures damage. Under 50 is strong play; over 100 suggests real errors.",
    "help.analytics.g_acpl_term": "Average CP lost",
    "help.analytics.g_cp_def": "One hundredth of a pawn. It is the unit engines use to score a position: +50 cp means you are half a pawn better, which may come from an advantage in space or activity rather than actual material.",
    "help.analytics.g_cp_term": "Centipawn (cp)",
    "help.analytics.g_fen_def": "Forsyth–Edwards Notation: one line of text describing a single position — where the pieces are, whose turn it is, and the castling and en-passant rights. ChessWiz uses it as the identity of a position, which is how a saved favorite or an AI explanation is tied to exactly one board.",
    "help.analytics.g_fen_term": "FEN",
    "help.analytics.g_pgn_def": "Portable Game Notation: the standard text format for a whole game — the players, the event, the result, and the full move list. It is what gets imported when your games are synced.",
    "help.analytics.g_pgn_term": "PGN",
    "help.analytics.g_precision_def": "The same information as average CP lost, expressed as a 0–100% score. It is scaled between two reference points: play that loses about 0.05 pawns per move scores near 100%, and play that loses about 2.2 pawns per move scores near 0%.",
    "help.analytics.g_precision_term": "Precision",
    "help.analytics.g_streak_def": "The longest run of consecutive moves you played that the engine rated as book, best, great or brilliant.",
    "help.analytics.g_streak_term": "Best-move streak",
    "help.analytics.h_glossary": "Chess terms used across the app",
    "help.analytics.h_progress": "Progress: are you improving?",
    "help.analytics.h_strategic": "Strategic Analytics",
    "help.analytics.p1": "Analytics answers two different questions. Strategic Analytics asks what keeps going wrong; Progress asks whether you are getting better. They are worth reading in that order.",
    "help.analytics.p2": "This screen groups your recurring weaknesses into four families — king safety, pawn structure, piece activity, and general principles — over a window of your recent games. The window is a month on the free plan and up to six months on Pro.",
    "help.analytics.p3": "You can view those patterns two ways. Occurrences counts how often a pattern shows up. Impact scores from 0% to 100% how much it actually costs you, combining how damaging the moves were with how strongly the pattern was present. A pattern can be frequent but cheap, or rare and expensive — impact is what tells them apart.",
    "help.analytics.p4": "Below that sits a grid of strategic and time metrics, which you can read as totals or week by week:",
    "help.analytics.p5": "Progress folds your games into weeks and tracks a handful of outcome metrics. Each one answers a different question about your play:",
    "help.analytics.p6": "Alongside those, an activity card tracks what you have actually been doing: your daily training streak, puzzles solved, games reviewed, alarms received, and a breakdown of the practice types you use. Free plans see the last few weeks; Pro sees the full history.",
    "help.analytics.teaser": "Strategic patterns, your progress over time, and the chess terms behind them.",
    "help.analytics.title": "Analytics",
    "help.contact.body_diagnostics": "App details",
    "help.contact.body_intro": "Describe your question or issue here:",
    "help.contact.cta": "Contact us",
    "help.contact.mail_failed": "Email us at {email}",
    "help.contact.subject": "ChessWiz support",
    "help.contact.subject_with_topic": "ChessWiz support — {topic}",
    "help.contact.subtitle": "We read every message. Tell us what you were trying to do and we'll help.",
    "help.contact.title": "Still have questions?",
    "help.index.intro": "Short guides to how ChessWiz works and how to get the most out of it.",
    "help.notifications.b_accept": "Accept adds the line to your opening practice so it shows up in your drills.",
    "help.notifications.b_godeeper": "Go deeper — the line runs past the depth you have already mastered, so it extends your book by one move.",
    "help.notifications.b_pointslost": "Points lost — how much the slip cost you in the game it came from.",
    "help.notifications.b_recent": "Recent occurrences — how many times this exact position came up in your recent games.",
    "help.notifications.b_skip": "Skip archives the suggestion.",
    "help.notifications.h_actions": "Accept and Skip",
    "help.notifications.h_review": "Reviewing the line",
    "help.notifications.h_why": "Why you're seeing a line",
    "help.notifications.p1": "When one of your favorite openings throws up a recurring mistake or a chance to learn the next move, ChessWiz drops a suggestion in your Notifications, grouped under \"Opening practice notifications\".",
    "help.notifications.p_review": "The board is a read-only review: step through the whole line with the first/back/forward/last controls or tap a move chip. On the final move, the green arrow is the book move to learn and the red arrow is what you played instead.",
    "help.notifications.p_why": "Each card explains itself so you know it is worth your time:",
    "help.notifications.teaser": "Weekly \"go deeper\" suggestions from your own opening mistakes, and what Accept and Skip do.",
    "help.notifications.tip_30days": "Skipped lines are not suggested again for 30 days — if the mistake keeps happening after that, it can come back.",
    "help.notifications.title": "Opening practice notifications",
    "help.openings.b_cleandepth": "Clean depth — the average move number you stayed accurate to before the first mistake. Deeper is better, and it is what the regression check watches.",
    "help.openings.b_firstslow": "Time to first long think — the earliest opening move where you spent longer than your think-time threshold. A later move means you are recalling your preparation instead of working it out at the board.",
    "help.openings.b_offbook": "Opponent off-book first — the share of games where your opponent left the engine's top 3 before you did. When this is high you are usually the one still in book, so you win the opening battle more often.",
    "help.openings.b_reoccurrence": "Reoccurrences — how often the same line showed up in your games that week. The lines you repeat most are the ones worth polishing first.",
    "help.openings.b_streak": "Engine top-3 streak — how many of your opening moves in a row (up to move 15) stayed within the engine's three best choices before your first slip. Higher means you followed your book further.",
    "help.openings.cta_analytics": "Open openings analytics",
    "help.openings.cta_settings": "Adjust your think-time threshold",
    "help.openings.h_favorites": "It follows your favorites",
    "help.openings.h_metrics": "What each number means",
    "help.openings.h_recs": "Practice suggestions",
    "help.openings.h_regressions": "Regressions",
    "help.openings.p1": "Openings analytics tracks how well you play the opening in the lines you care about most. It looks only at your favorite opening lines and turns each week of games into a small set of numbers you can watch trend over time.",
    "help.openings.p2": "Every opening you mark as a favorite in Practice becomes a tracked line here, split by the colour you play it as. Favorite a few lines and give it a week of games — the charts fill in as new games are analyzed.",
    "help.openings.p3": "Each favorite line gets a scorecard and a weekly timeline built from these metrics:",
    "help.openings.p4": "When a line's clean depth this week drops below the depth you had reached before, we flag it as a regression — a sign a mistake is now creeping in earlier than it used to. These lines are surfaced first under \"Needs attention\" so you know what to review.",
    "help.openings.p5": "When we notice you leaving your book in a real game, we turn that moment into a ready-made practice line and drop it into your notifications inbox. Your weekly report also reminds you how many opening lines are waiting to be reviewed.",
    "help.openings.teaser": "What the engine-streak, off-book and time-to-think charts on your favorite lines mean.",
    "help.openings.tip_threshold": "You set the think-time threshold in Settings. It defaults to a value based on your rating; lower it if you are a stronger player, raise it if you want more slack.",
    "help.openings.title": "Openings analytics",
    "help.plans.cta_subscription": "See plans and upgrade",
    "help.plans.free_alarms": "Unlimited alarm sessions.",
    "help.plans.free_askai": "One Ask AI explanation per day.",
    "help.plans.free_history": "Up to 2 months of history imported, and up to 100 games per import.",
    "help.plans.free_lookback": "Practice and review look back over the last 7 days.",
    "help.plans.free_puzzles": "Curated strategic puzzles unlock in order — you need to solve 70% of a difficulty before the next one opens.",
    "help.plans.free_sites": "One linked chess account.",
    "help.plans.h_free": "Free",
    "help.plans.h_pro": "Pro",
    "help.plans.p1": "ChessWiz has two plans: Free and Pro. Everything listed below is enforced by the app, so it is exactly what changes when you upgrade.",
    "help.plans.pro_alarms": "Unlimited alarm sessions — every session that matches your criteria reaches you.",
    "help.plans.pro_askai": "Unlimited Ask AI explanations.",
    "help.plans.pro_finetune": "Fine-tune controls for your practice criteria: move range, points lost, time spent, and time controls.",
    "help.plans.pro_history": "Up to 12 months of history, and up to 1000 games per import.",
    "help.plans.pro_lookback": "Practice and review look back up to 180 days, and you choose the window.",
    "help.plans.pro_puzzles": "Every curated puzzle difficulty is open from the start.",
    "help.plans.pro_sites": "Up to 4 linked chess accounts.",
    "help.plans.teaser": "What Free includes, and what changes on Pro.",
    "help.plans.tip_data": "Your linked accounts, favorites and history stay where they are when you change plan. Upgrading widens the limits; it does not reset anything.",
    "help.plans.title": "Subscription plans",
    "help.practices.b_daily_alarm": "Your recurring-mistake flashcards always come last.",
    "help.practices.b_daily_anchor": "Engine mistakes, openings and your alarm review are always included whenever they have content.",
    "help.practices.b_daily_mix": "Tasks mix the practice types above, and the optional ones rotate from day to day so you are not handed the same set every time.",
    "help.practices.b_daily_size": "The set holds four to eight tasks depending on how much you played — more games, more tasks.",
    "help.practices.b_engine_mistakes": "Engine Mistakes — a queue of your own flagged moves, selected by your practice criteria.",
    "help.practices.b_engine_rush": "Engine Rush — pick up one of your own middlegames and keep finding engine-approved moves.",
    "help.practices.b_favorites": "Favorites — the positions you starred as worth remembering.",
    "help.practices.b_good_decision": "Good Decision? — decide whether a strategic choice you made was sound.",
    "help.practices.b_guess_eval": "Guess the Evaluation — judge who is better and by how much, then compare with the engine.",
    "help.practices.b_move_verdict": "Flashcard Puzzles — a position and a single move; swipe to say whether it was the best move.",
    "help.practices.b_rush": "Puzzle Rush — solve as many as you can before the three-minute timer runs out.",
    "help.practices.b_streak": "Puzzle Streak — solve positions from your games back to back; one miss ends the run.",
    "help.practices.b_worst_move": "Spot the Worst Move — find the worst move among the candidates and build a streak.",
    "help.practices.b_worst_piece": "Worst Piece? — pick out your worst-placed piece in a position from one of your games.",
    "help.practices.cta_daily": "Open daily training",
    "help.practices.cta_practice": "Browse all practice modes",
    "help.practices.h_daily": "Daily training",
    "help.practices.h_notyours": "Not from your games",
    "help.practices.h_yourgames": "Built from your games",
    "help.practices.p1": "Most chess apps hand you puzzles from a shared database. ChessWiz mostly does the opposite: your practice is built from positions you actually reached and mistakes you actually made. That is also why the same idea keeps coming back — it is a habit of yours, not a random puzzle.",
    "help.practices.p2": "Openings Practice plays lines from a standard opening catalog, but it puts the families and lines you actually play first, and highlights the moves where you have gone wrong before.",
    "help.practices.p3": "Curated Strategic Puzzles is a human-reviewed library organised by strategic theme and difficulty. It is the one mode that is not based on your own games.",
    "help.practices.p4": "Daily training is a short set built fresh each day from the games you played the day before, once they have been analyzed.",
    "help.practices.p5": "Finishing every task completes the day and extends your streak. Skipping a task leaves the day open. A new set is built each day, so there is nothing to reset.",
    "help.practices.teaser": "Puzzles built from your own games, plus your daily training set.",
    "help.practices.title": "Practice",
    "help.review.b_arrows": "The engine's three best continuations are drawn as numbered arrows, 1 to 3. When a green \"you should have played this\" arrow is already on the board, the numbered arrows switch to amber so the two never get confused.",
    "help.review.b_askai_anchor": "The question is anchored to the position just before your move, so the answer is about the move you missed — not about your opponent's reply.",
    "help.review.b_askai_limit": "It is available up to move 30. On the free plan you get one explanation per day; Pro is unlimited.",
    "help.review.b_askai_when": "It appears on your own inaccuracies, mistakes, blunders and misses, while you are stepping through the game rather than in engine analysis.",
    "help.review.b_categories": "Every move is graded: brilliant, great, best, excellent, good, book, inaccuracy, mistake, blunder, or miss. A miss is different from a blunder — it means you let a decisive advantage or a forced mate slip, not that you lost the position.",
    "help.review.b_evalbar": "The evaluation bar tracks who stands better. You can add a horizontal bar as well from the More menu.",
    "help.review.b_g_clock": "Tap the clock chip to jump straight to the time timeline for the game.",
    "help.review.b_g_longpress_arrows": "Hold the navigation arrows to step quickly through the moves instead of tapping repeatedly.",
    "help.review.b_g_longpress_piece": "Long-press any piece on the board to open its insight card — whether it is active or passive and why, tempi lost, and for pawns whether it is passed, backward, isolated, doubled or hanging.",
    "help.review.b_g_swipe_down": "Swipe down, when already scrolled to the top, to go back to the games list.",
    "help.review.b_g_swipe_games": "Swipe left and right when you are not analysing to move to the previous or next game in your list.",
    "help.review.b_g_swipe_panels": "Swipe left and right while analysing to cycle the panels: engine, summary, pieces, move, plans, concepts. Swiping past either end leaves analysis.",
    "help.review.b_g_tap_piece": "Tap a piece while simply reviewing the game to jump straight into engine analysis.",
    "help.review.b_precision": "Each player gets a precision percentage for the game, alongside average centipawn loss.",
    "help.review.cta_games": "Open your games",
    "help.review.h_askai": "Ask AI",
    "help.review.h_coach": "The coach",
    "help.review.h_engine": "What the engine shows you",
    "help.review.h_favorites": "Favorites, notes and openings",
    "help.review.h_gestures": "Gestures worth knowing",
    "help.review.h_strategic": "Strategic concepts and motifs",
    "help.review.p1": "Opening one of your games gives you far more than an engine line. The same screen holds the engine, a coach that explains the position in words, the strategic concepts behind each move, and a way to save anything worth coming back to.",
    "help.review.p2": "The bulb next to the material count turns the coach on. Tapping it cycles through a position summary, an explanation of the move you just played, and then a muted state — tap once more to return to off.",
    "help.review.p3": "The bulb pulses and keeps a small dot whenever the move you are standing on has something for the coach to say, so you can step through a game and only stop where it matters.",
    "help.review.p4": "Beyond the evaluation, each move is compared strategically: what improved and what got worse, grouped into king safety, pawn structure, piece activity, and general principles. Trade-offs show as both at once — you improved one thing and damaged another.",
    "help.review.p5": "Ask AI turns one of your mistakes into something you can actually remember: a short hook plus a sentence or two explaining why the better move was better. It is a memory aid for that position, not a chat.",
    "help.review.p6": "The star saves the current position as a puzzle you can practise later. It always saves the position where it is your turn, so if you are looking at your own move it rewinds one ply for you. It works on any move, not only on mistakes.",
    "help.review.teaser": "The coach, Ask AI, strategic concepts, and the gestures that aren't obvious.",
    "help.review.tip_longpress_star": "Long-press the star instead of tapping it and you get a choice: save it as a favorite with a note attached, or store the line as an opening to practise. Notes are optional and up to 200 characters.",
    "help.review.tip_squares": "When an insight names a square, that square is a chip you can tap — the square then pulses amber on the board, so you can see what the sentence is talking about.",
    "help.review.title": "Game review",
    "help.screen_title": "Help"
  },
  "pt": {
    "help.about.alarms_desc": "Um aviso quando você escorrega, para aprender com a partida ainda fresca.",
    "help.about.alarms_title": "Alarmes de erros",
    "help.about.body": "O ChessWiz ajuda jogadores casuais a melhorar — usando as partidas que você já joga. Conecte sua conta do Chess.com ou Lichess e ele aprende com seus erros reais para criar um treino só para você.",
    "help.about.daily_desc": "Um treino diário curto a partir das suas partidas, mais as posições que você salvou para rever.",
    "help.about.daily_title": "Treino diário e favoritos",
    "help.about.practice_desc": "Exercícios criados a partir das suas partidas e dos seus pontos fracos.",
    "help.about.practice_title": "Treino feito para você",
    "help.about.reviews_desc": "Cada partida é revisada automaticamente, sem configurar nada.",
    "help.about.reviews_title": "Revisão automática das partidas",
    "help.about.title": "O que o ChessWiz faz",
    "help.alarms.b_categories": "As categorias de lance que interessam a você: lances brilhantes, erros no início da partida, erros cometidos depois de pensar muito, mates forçados que passaram batido e erros graves.",
    "help.alarms.b_email": "E-mail: alarmes da mesma sessão continuam a mesma conversa em vez de começar outra, então sua caixa de entrada mantém uma thread por tipo de alarme, e não uma mensagem por lance.",
    "help.alarms.b_freecap": "Os alarmes são ilimitados em todos os planos, inclusive no Gratuito: toda sessão que bate com seus critérios chega até você.",
    "help.alarms.b_lookback": "Até quando no passado procuramos lances que se encaixem.",
    "help.alarms.b_push": "Push: você é avisado uma única vez, no início da sessão. Os alarmes seguintes dessa mesma sessão entram silenciosamente, sem um segundo aviso.",
    "help.alarms.b_timepressure": "Se lances jogados sob pressão de tempo são excluídos. Por padrão, são.",
    "help.alarms.cta_settings": "Abrir seus critérios de prática",
    "help.alarms.h_alarm": "O que é um alarme",
    "help.alarms.h_practice": "Os mesmos critérios alimentam sua prática",
    "help.alarms.h_session": "A sessão de 30 minutos",
    "help.alarms.p1": "Quando você vincula uma conta do Chess.com ou do Lichess, o ChessWiz importa suas partidas e as analisa nos nossos servidores. Isso não acontece só uma vez: enquanto a conta continuar vinculada, seguimos buscando partidas novas e analisando tudo automaticamente. Você nunca precisa enviar nada manualmente.",
    "help.alarms.p2": "Partidas novas são buscadas cerca de uma vez por hora em cada conta vinculada, e a análise roda em segundo plano — então normalmente dá para revisar uma partida poucos minutos depois de terminá-la.",
    "help.alarms.p3": "Assim que a partida é analisada, cada lance que você jogou é comparado com os seus critérios de prática. O lance que se encaixa vira um alarme, e nós o enviamos por e-mail e por notificação push.",
    "help.alarms.p4": "Seus critérios decidem tudo sobre quais lances chegam até você:",
    "help.alarms.p5": "No Pro você também pode ajustar os critérios em detalhe: um intervalo de número de lance, um mínimo de pontos perdidos, quanto tempo você gastou no lance, quais ritmos de jogo contam e se um erro repetido deve sempre avisar você.",
    "help.alarms.p6": "Os alarmes são agrupados em sessões. Uma sessão fica aberta por 30 minutos, e cada novo alarme a prolonga por mais 30 minutos.",
    "help.alarms.p7": "É por isso que uma maratona de partidas raramente vira uma enxurrada de notificações.",
    "help.alarms.p8": "A prática de Erros do motor é montada exatamente com os mesmos critérios dos seus alarmes. Ampliar as categorias ou o período de busca gera mais notificações e também uma fila de prática maior; restringi-los deixa as duas coisas mais seletivas.",
    "help.alarms.teaser": "Como suas partidas são analisadas automaticamente e quando avisamos você.",
    "help.alarms.tip_wizard": "Se você nunca concluiu o assistente de critérios de prática, nenhum alarme é gerado. Basta concluí-lo uma vez para ativá-los.",
    "help.alarms.title": "Análise, contas vinculadas e alarmes",
    "help.analytics.b_m_acpl": "Perda média de CP: veja o glossário abaixo. Quanto menor, melhor.",
    "help.analytics.b_m_comeback": "Viradas: partidas que você venceu depois de estar em −3 ou pior.",
    "help.analytics.b_m_exchange": "Erros de trocas: trocas que deixaram sua posição pior.",
    "help.analytics.b_m_forced": "Resposta difícil forçada ao adversário: com que frequência seu lance deixou ao adversário uma única resposta estreita.",
    "help.analytics.b_m_longthink": "Pensar muito com várias opções boas: com que frequência você gastou tempo em posições em que vários lances serviam.",
    "help.analytics.b_m_ontime": "Porcentagem de partidas perdidas no tempo.",
    "help.analytics.b_m_ontime_winning": "Perdidas no tempo estando ganhando: quedas de bandeira com a posição claramente a seu favor.",
    "help.analytics.b_m_pawn": "Erros de estrutura de peões: erros estratégicos envolvendo estruturas de peões frágeis.",
    "help.analytics.b_m_slipped": "Partidas com vantagem de +3 desperdiçada: posições ganhas que terminaram em derrota.",
    "help.analytics.b_m_streak": "Maior sequência de lances: sua série mais longa de lances de livro, brilhantes, ótimos ou melhores.",
    "help.analytics.b_m_tempos": "Tempos perdidos em média por partida, por desenvolvimento e ordem de lances ineficientes.",
    "help.analytics.b_m_wontime_lost": "Ganhas no tempo estando completamente perdido: a imagem invertida, por honestidade.",
    "help.analytics.b_p_equal": "Igual ou melhor até: o número do lance até o qual você ainda não estava perdendo, tomado como valor do meio da semana. É a métrica que revela se suas aberturas estão segurando.",
    "help.analytics.b_p_precision": "Precisão: o quanto seus lances chegaram perto dos do motor, na média das partidas da semana. Veja o glossário.",
    "help.analytics.b_p_rating": "Rating: sua pontuação no fim de cada semana. A medida mais direta e também a mais instável.",
    "help.analytics.b_p_time": "Partidas com vantagem de tempo: a fatia de partidas em que você manteve mais tempo no relógio que o adversário na maior parte do jogo.",
    "help.analytics.b_p_winshare": "Fatia de vantagem: a porcentagem dos seus próprios lances após os quais você estava pelo menos um terço de peão melhor. Mede quanto das suas partidas você passa na frente, não como elas terminaram.",
    "help.analytics.cta_analytics": "Abrir análises",
    "help.analytics.g_acpl_def": "Para cada lance seu, quantos centipeões aquele lance entregou em relação ao melhor lance, e depois a média entre todos os seus lances. Os lances bons contam como zero em vez de compensar os erros, então o número mede só o estrago. Abaixo de 50 é jogo forte; acima de 100 indica erros reais.",
    "help.analytics.g_acpl_term": "Perda média de CP",
    "help.analytics.g_cp_def": "Um centésimo de peão. É a unidade com que os motores pontuam uma posição: +50 cp quer dizer que você está meio peão melhor, o que pode vir de vantagem de espaço ou de atividade, e não de material de verdade.",
    "help.analytics.g_cp_term": "Centipeão (cp)",
    "help.analytics.g_fen_def": "Notação Forsyth-Edwards: uma linha de texto que descreve uma única posição, com onde estão as peças, de quem é a vez e os direitos de roque e de captura en passant. O ChessWiz a usa como identidade de uma posição, e é assim que um favorito salvo ou uma explicação da IA ficam presos a um tabuleiro específico.",
    "help.analytics.g_fen_term": "FEN",
    "help.analytics.g_pgn_def": "Portable Game Notation: o formato de texto padrão para uma partida inteira, com os jogadores, o evento, o resultado e a lista completa de lances. É o que é importado quando suas partidas são sincronizadas.",
    "help.analytics.g_pgn_term": "PGN",
    "help.analytics.g_precision_def": "A mesma informação da perda média de CP, expressa como uma nota de 0 a 100%. Ela é escalada entre duas referências: um jogo que perde cerca de 0,05 peão por lance chega perto de 100%, e um que perde cerca de 2,2 peões por lance chega perto de 0%.",
    "help.analytics.g_precision_term": "Precisão",
    "help.analytics.g_streak_def": "A maior sequência de lances consecutivos seus que o motor classificou como de livro, melhor, ótimo ou brilhante.",
    "help.analytics.g_streak_term": "Sequência de melhores lances",
    "help.analytics.h_glossary": "Termos de xadrez usados no app",
    "help.analytics.h_progress": "Progresso: você está melhorando?",
    "help.analytics.h_strategic": "Análises estratégicas",
    "help.analytics.p1": "As análises respondem a duas perguntas diferentes. As Análises estratégicas perguntam o que continua dando errado; o Progresso pergunta se você está melhorando. Vale ler nessa ordem.",
    "help.analytics.p2": "Esta tela agrupa suas fraquezas recorrentes em quatro famílias — segurança do rei, estrutura de peões, atividade das peças e princípios gerais — dentro de uma janela das suas partidas recentes. A janela é de um mês no plano gratuito e de até seis meses no Pro.",
    "help.analytics.p3": "Dá para ver esses padrões de duas formas. Ocorrências conta quantas vezes um padrão aparece. Impacto dá uma nota de 0% a 100% para o quanto ele realmente custa, combinando o estrago dos lances com a intensidade do padrão. Um padrão pode ser frequente e barato, ou raro e caríssimo: é o impacto que separa os dois.",
    "help.analytics.p4": "Abaixo fica uma grade de métricas estratégicas e de tempo, que você pode ler como totais ou semana a semana:",
    "help.analytics.p5": "O Progresso agrupa suas partidas por semana e acompanha algumas métricas de resultado. Cada uma responde a uma pergunta diferente sobre o seu jogo:",
    "help.analytics.p6": "Ao lado disso, um cartão de atividade registra o que você realmente andou fazendo: sua sequência de treino diário, puzzles resolvidos, partidas revisadas, alarmes recebidos e uma divisão dos tipos de prática que você usa. O plano gratuito vê as últimas semanas; o Pro vê o histórico inteiro.",
    "help.analytics.teaser": "Padrões estratégicos, seu progresso ao longo do tempo e os termos de xadrez por trás disso.",
    "help.analytics.title": "Análises",
    "help.contact.body_diagnostics": "Dados do app",
    "help.contact.body_intro": "Descreva aqui sua dúvida ou problema:",
    "help.contact.cta": "Fale conosco",
    "help.contact.mail_failed": "Escreva para {email}",
    "help.contact.subject": "Suporte do ChessWiz",
    "help.contact.subject_with_topic": "Suporte do ChessWiz — {topic}",
    "help.contact.subtitle": "Lemos todas as mensagens. Conte o que você estava tentando fazer e nós ajudamos.",
    "help.contact.title": "Ainda tem dúvidas?",
    "help.index.intro": "Guias curtos sobre como o ChessWiz funciona e como aproveitá-lo ao máximo.",
    "help.notifications.b_accept": "Aceitar adiciona a linha à sua prática de aberturas para aparecer nos seus exercícios.",
    "help.notifications.b_godeeper": "Ir mais fundo — a linha vai além da profundidade que você já domina, ampliando seu repertório em um lance.",
    "help.notifications.b_pointslost": "Pontos perdidos — quanto o deslize custou na partida de onde veio.",
    "help.notifications.b_recent": "Ocorrências recentes — quantas vezes esta posição exata surgiu nas suas partidas recentes.",
    "help.notifications.b_skip": "Pular arquiva a sugestão.",
    "help.notifications.h_actions": "Aceitar e Pular",
    "help.notifications.h_review": "Revisando a linha",
    "help.notifications.h_why": "Por que você está vendo uma linha",
    "help.notifications.p1": "Quando uma das suas aberturas favoritas revela um erro recorrente ou uma chance de aprender o próximo lance, o ChessWiz deixa uma sugestão nas suas Notificações, agrupada em \"Notificações de prática de aberturas\".",
    "help.notifications.p_review": "O tabuleiro é uma revisão somente leitura: percorra toda a linha com os controles primeiro/voltar/avançar/último ou toque em uma ficha de lance. No lance final, a seta verde é o lance de livro a aprender e a vermelha é o que você jogou no lugar.",
    "help.notifications.p_why": "Cada cartão se explica para você saber que vale o seu tempo:",
    "help.notifications.teaser": "Sugestões semanais para \"ir mais fundo\" a partir dos seus próprios erros de abertura, e o que Aceitar e Pular fazem.",
    "help.notifications.tip_30days": "Linhas puladas não são sugeridas novamente por 30 dias; se o erro continuar depois disso, ela pode voltar.",
    "help.notifications.title": "Notificações de prática de aberturas",
    "help.openings.b_cleandepth": "Profundidade limpa — o número médio de lance até onde você se manteve preciso antes do primeiro erro. Quanto mais profunda, melhor, e é o que a verificação de regressão observa.",
    "help.openings.b_firstslow": "Tempo até a primeira reflexão longa — o lance de abertura mais cedo em que você demorou mais do que o seu limite de reflexão. Um lance mais tardio significa que você está lembrando da sua preparação em vez de calculá-la no tabuleiro.",
    "help.openings.b_offbook": "Adversário sai do livro primeiro — o percentual de partidas em que seu adversário saiu do top 3 do motor antes de você. Quando isso é alto, normalmente é você quem ainda está no livro, então você vence a batalha da abertura com mais frequência.",
    "help.openings.b_reoccurrence": "Repetições — com que frequência a mesma linha apareceu nas suas partidas naquela semana. As linhas que você mais repete são as primeiras que vale a pena lapidar.",
    "help.openings.b_streak": "Sequência no top-3 do motor — quantos dos seus lances de abertura seguidos (até o lance 15) ficaram entre as três melhores opções do motor antes do seu primeiro escorregão. Quanto maior, mais longe você seguiu seu livro.",
    "help.openings.cta_analytics": "Abrir análises de aberturas",
    "help.openings.cta_settings": "Ajustar seu limite de reflexão",
    "help.openings.h_favorites": "Ela segue suas favoritas",
    "help.openings.h_metrics": "O que cada número significa",
    "help.openings.h_recs": "Sugestões de prática",
    "help.openings.h_regressions": "Regressões",
    "help.openings.p1": "As análises de aberturas acompanham o quão bem você joga a abertura nas linhas que mais lhe importam. Elas olham apenas para suas aberturas favoritas e transformam cada semana de partidas em um pequeno conjunto de números cuja tendência você pode acompanhar ao longo do tempo.",
    "help.openings.p2": "Cada abertura que você marca como favorita em Prática vira aqui uma linha acompanhada, separada pela cor com que você a joga. Marque algumas linhas e dê a elas uma semana de partidas: os gráficos vão se preenchendo à medida que novas partidas são analisadas.",
    "help.openings.p3": "Cada linha favorita ganha um cartão e uma linha do tempo semanal montados a partir destas métricas:",
    "help.openings.p4": "Quando a profundidade limpa de uma linha nesta semana cai abaixo da profundidade que você já havia alcançado antes, nós a marcamos como regressão — sinal de que um erro está agora aparecendo mais cedo do que costumava. Essas linhas aparecem primeiro em \"Requer atenção\" para que você saiba o que revisar.",
    "help.openings.p5": "Quando percebemos que você saiu do seu livro em uma partida real, transformamos esse momento em uma linha de prática pronta e a colocamos na sua caixa de notificações. Seu relatório semanal também lembra quantas linhas de abertura estão esperando revisão.",
    "help.openings.teaser": "O que significam os gráficos de sequência do motor, saída do livro e tempo de reflexão nas suas linhas favoritas.",
    "help.openings.tip_threshold": "Você define o limite de reflexão em Ajustes. Ele assume um valor padrão com base no seu rating; diminua-o se você for um jogador mais forte ou aumente-o se quiser mais folga.",
    "help.openings.title": "Análises de aberturas",
    "help.plans.cta_subscription": "Ver planos e fazer upgrade",
    "help.plans.free_alarms": "Sessões de alarmes ilimitadas.",
    "help.plans.free_askai": "Uma explicação do Pergunte à IA por dia.",
    "help.plans.free_history": "Até 2 meses de histórico importado e até 100 partidas por importação.",
    "help.plans.free_lookback": "A prática e a revisão consideram os últimos 7 dias.",
    "help.plans.free_puzzles": "Os puzzles estratégicos selecionados são liberados em ordem: você precisa resolver 70% de um nível de dificuldade antes de o próximo abrir.",
    "help.plans.free_sites": "Uma conta de xadrez vinculada.",
    "help.plans.h_free": "Gratuito",
    "help.plans.h_pro": "Pro",
    "help.plans.p1": "O ChessWiz tem dois planos: Gratuito e Pro. Tudo o que está listado abaixo é aplicado de fato pelo app, então é exatamente o que muda quando você faz o upgrade.",
    "help.plans.pro_alarms": "Sessões de alarmes ilimitadas: toda sessão que bate com seus critérios chega até você.",
    "help.plans.pro_askai": "Explicações do Pergunte à IA ilimitadas.",
    "help.plans.pro_finetune": "Controles de ajuste fino para seus critérios de prática: intervalo de lances, pontos perdidos, tempo gasto e ritmos de jogo.",
    "help.plans.pro_history": "Até 12 meses de histórico e até 1000 partidas por importação.",
    "help.plans.pro_lookback": "A prática e a revisão alcançam até 180 dias, e você escolhe o período.",
    "help.plans.pro_puzzles": "Todos os níveis de dificuldade dos puzzles selecionados ficam abertos desde o começo.",
    "help.plans.pro_sites": "Até 4 contas de xadrez vinculadas.",
    "help.plans.teaser": "O que o plano gratuito inclui e o que muda no Pro.",
    "help.plans.tip_data": "Suas contas vinculadas, seus favoritos e seu histórico continuam onde estão quando você troca de plano. Fazer upgrade amplia os limites; não apaga nada.",
    "help.plans.title": "Planos de assinatura",
    "help.practices.b_daily_alarm": "Seus flashcards de erros recorrentes vêm sempre por último.",
    "help.practices.b_daily_anchor": "Erros do motor, aberturas e a revisão dos seus alarmes entram sempre que tiverem conteúdo.",
    "help.practices.b_daily_mix": "As tarefas misturam os tipos de prática acima, e as opcionais giram de um dia para o outro, então você não recebe sempre a mesma série.",
    "help.practices.b_daily_size": "A série tem de quatro a oito tarefas, conforme o quanto você jogou: mais partidas, mais tarefas.",
    "help.practices.b_engine_mistakes": "Erros do motor: uma fila com os seus próprios lances marcados, selecionados pelos seus critérios de prática.",
    "help.practices.b_engine_rush": "Engine Rush: retome um dos seus meios-jogos e continue achando lances aprovados pelo motor.",
    "help.practices.b_favorites": "Favoritos: as posições que você marcou como dignas de lembrar.",
    "help.practices.b_good_decision": "Boa decisão?: decida se uma escolha estratégica que você fez foi acertada.",
    "help.practices.b_guess_eval": "Adivinhe a avaliação: julgue quem está melhor e por quanto, e compare com o motor.",
    "help.practices.b_move_verdict": "Puzzles flashcard: uma posição e um único lance; deslize para dizer se era o melhor lance.",
    "help.practices.b_rush": "Puzzle Rush: resolva o máximo que conseguir antes de o cronômetro de três minutos zerar.",
    "help.practices.b_streak": "Sequência de puzzles: resolva posições das suas partidas uma atrás da outra; um erro encerra a sequência.",
    "help.practices.b_worst_move": "Ache o pior lance: encontre o pior lance entre os candidatos e emende uma sequência.",
    "help.practices.b_worst_piece": "Pior peça?: aponte a sua peça pior colocada em uma posição de uma das suas partidas.",
    "help.practices.cta_daily": "Abrir o treino diário",
    "help.practices.cta_practice": "Ver todos os modos de prática",
    "help.practices.h_daily": "Treino diário",
    "help.practices.h_notyours": "O que não vem das suas partidas",
    "help.practices.h_yourgames": "Montado a partir das suas partidas",
    "help.practices.p1": "A maioria dos apps de xadrez entrega puzzles de um banco de dados compartilhado. O ChessWiz faz quase o contrário: sua prática é montada com posições que você realmente alcançou e erros que você realmente cometeu. É por isso também que a mesma ideia volta sempre: é um hábito seu, não um puzzle aleatório.",
    "help.practices.p2": "A Prática de aberturas joga linhas de um catálogo padrão de aberturas, mas coloca na frente as famílias e linhas que você realmente joga, e destaca os lances em que você já errou antes.",
    "help.practices.p3": "Os Puzzles estratégicos selecionados são uma biblioteca revisada por pessoas e organizada por tema estratégico e dificuldade. É o único modo que não parte das suas próprias partidas.",
    "help.practices.p4": "O treino diário é uma série curta montada todo dia a partir das partidas que você jogou no dia anterior, depois de analisadas.",
    "help.practices.p5": "Concluir todas as tarefas fecha o dia e aumenta sua sequência. Pular uma tarefa deixa o dia em aberto. Uma série nova é montada a cada dia, então não há nada para reiniciar.",
    "help.practices.teaser": "Puzzles montados a partir das suas próprias partidas, além do treino diário.",
    "help.practices.title": "Prática",
    "help.review.b_arrows": "As três melhores continuações do motor aparecem como setas numeradas de 1 a 3. Quando já existe no tabuleiro uma seta verde de \"você deveria ter jogado isto\", as setas numeradas mudam para âmbar para que nunca se confundam.",
    "help.review.b_askai_anchor": "A pergunta é ancorada na posição imediatamente antes do seu lance, então a resposta trata do lance que passou batido, e não da resposta do adversário.",
    "help.review.b_askai_limit": "Está disponível até o lance 30. No plano gratuito você tem uma explicação por dia; no Pro são ilimitadas.",
    "help.review.b_askai_when": "Ele aparece nas suas próprias imprecisões, erros, erros graves e lances perdidos, enquanto você percorre a partida — não dentro da análise do motor.",
    "help.review.b_categories": "Cada lance recebe uma nota: brilhante, ótimo, melhor, excelente, bom, de livro, imprecisão, erro, erro grave ou lance perdido. Um lance perdido não é a mesma coisa que um erro grave: significa que você deixou escapar uma vantagem decisiva ou um mate forçado, não que perdeu a posição.",
    "help.review.b_evalbar": "A barra de avaliação mostra quem está melhor. Pelo menu Mais você também pode acrescentar uma barra horizontal.",
    "help.review.b_g_clock": "Toque na etiqueta do relógio para ir direto à linha do tempo da partida.",
    "help.review.b_g_longpress_arrows": "Segure as setas de navegação para avançar rápido pelos lances em vez de ficar tocando repetidamente.",
    "help.review.b_g_longpress_piece": "Segure qualquer peça no tabuleiro para abrir a ficha dela: se está ativa ou passiva e por quê, os tempos perdidos e, no caso dos peões, se está passado, atrasado, isolado, dobrado ou pendurado.",
    "help.review.b_g_swipe_down": "Deslize para baixo, já com a tela toda no topo, para voltar à lista de partidas.",
    "help.review.b_g_swipe_games": "Deslize para os lados quando não estiver analisando para ir à partida anterior ou à seguinte da sua lista.",
    "help.review.b_g_swipe_panels": "Deslize para os lados durante a análise para percorrer os painéis: motor, resumo, peças, lance, planos e conceitos. Passando de qualquer uma das pontas, você sai da análise.",
    "help.review.b_g_tap_piece": "Toque numa peça enquanto apenas revê a partida para ir direto para a análise do motor.",
    "help.review.b_precision": "Cada jogador recebe uma porcentagem de precisão da partida, junto com a perda média de centipeões.",
    "help.review.cta_games": "Abrir suas partidas",
    "help.review.h_askai": "Pergunte à IA",
    "help.review.h_coach": "O treinador",
    "help.review.h_engine": "O que o motor mostra",
    "help.review.h_favorites": "Favoritos, notas e aberturas",
    "help.review.h_gestures": "Gestos que vale conhecer",
    "help.review.h_strategic": "Conceitos e motivos estratégicos",
    "help.review.p1": "Abrir uma das suas partidas dá muito mais do que uma linha do motor. Na mesma tela estão o motor, um treinador que explica a posição em palavras, os conceitos estratégicos por trás de cada lance e um jeito de guardar tudo o que valer a pena rever.",
    "help.review.p2": "A lâmpada ao lado da contagem de material liga o treinador. Tocando nela você passa por um resumo da posição, uma explicação do lance que acabou de jogar e depois um estado silenciado; mais um toque e ela volta a desligar.",
    "help.review.p3": "A lâmpada pisca e mantém um pontinho sempre que o lance em que você está tem algo a comentar, então dá para percorrer a partida e parar só onde importa.",
    "help.review.p4": "Além da avaliação, cada lance é comparado no plano estratégico: o que melhorou e o que piorou, agrupado em segurança do rei, estrutura de peões, atividade das peças e princípios gerais. As trocas de vantagem aparecem como as duas coisas ao mesmo tempo: você melhorou uma coisa e estragou outra.",
    "help.review.p5": "O Pergunte à IA transforma um erro seu em algo que dá para lembrar de verdade: uma frase-gancho curta mais uma ou duas linhas explicando por que o lance melhor era melhor. É um apoio de memória para aquela posição, não um chat.",
    "help.review.p6": "A estrela salva a posição atual como um puzzle para praticar depois. Ela sempre salva a posição em que é a sua vez de jogar, então, se você estiver olhando o seu próprio lance, ela volta meio lance por você. Funciona em qualquer lance, não só nos erros.",
    "help.review.teaser": "O treinador, o Pergunte à IA, os conceitos estratégicos e os gestos menos óbvios.",
    "help.review.tip_longpress_star": "Segure a estrela em vez de tocá-la e você escolhe: salvar como favorito com uma nota, ou guardar a linha como abertura para praticar. As notas são opcionais e aceitam até 200 caracteres.",
    "help.review.tip_squares": "Quando uma observação cita uma casa, essa casa é um botão em que você pode tocar: ela então pisca em âmbar no tabuleiro, para você ver do que a frase está falando.",
    "help.review.title": "Revisão de partidas",
    "help.screen_title": "Ajuda"
  },
  "es": {
    "help.about.alarms_desc": "Un aviso cuando fallas, para aprender con la partida aún fresca.",
    "help.about.alarms_title": "Alarmas de errores",
    "help.about.body": "ChessWiz ayuda a los jugadores casuales a mejorar — usando las partidas que ya juegas. Conecta tu cuenta de Chess.com o Lichess y aprende de tus errores reales para crear entrenamiento solo para ti.",
    "help.about.daily_desc": "Un entrenamiento diario corto a partir de tus partidas, más las posiciones que guardaste para repasar.",
    "help.about.daily_title": "Entrenamiento diario y favoritos",
    "help.about.practice_desc": "Ejercicios creados a partir de tus partidas y tus puntos débiles.",
    "help.about.practice_title": "Práctica hecha para ti",
    "help.about.reviews_desc": "Cada partida se revisa automáticamente, sin configurar nada.",
    "help.about.reviews_title": "Revisión automática de partidas",
    "help.about.title": "Qué hace ChessWiz",
    "help.alarms.b_categories": "Las categorías de jugada que te interesan: jugadas brillantes, errores tempranos, errores tras pensar mucho tiempo, mates forzados que no viste y garrafales.",
    "help.alarms.b_email": "Correo: las alarmas de una misma sesión continúan la misma conversación en lugar de abrir una nueva, así tu bandeja mantiene un hilo por tipo de alarma en vez de un mensaje por jugada.",
    "help.alarms.b_freecap": "Las alarmas son ilimitadas en todos los planes, incluido el Gratis: te llega toda sesión que cumpla tus criterios.",
    "help.alarms.b_lookback": "Cuánto tiempo atrás buscamos jugadas que coincidan.",
    "help.alarms.b_push": "Push: recibes un aviso una sola vez, al abrirse la sesión. Las alarmas posteriores de esa misma sesión se añaden en silencio, sin un segundo aviso.",
    "help.alarms.b_timepressure": "Si se excluyen las jugadas hechas con apuros de tiempo. Por defecto, se excluyen.",
    "help.alarms.cta_settings": "Abrir tus criterios de práctica",
    "help.alarms.h_alarm": "Qué es una alarma",
    "help.alarms.h_practice": "Los mismos criterios alimentan tu práctica",
    "help.alarms.h_session": "La sesión de 30 minutos",
    "help.alarms.p1": "Cuando vinculas una cuenta de Chess.com o Lichess, ChessWiz importa tus partidas y las analiza en nuestros servidores. No es algo puntual: mientras la cuenta siga vinculada, seguimos buscando partidas nuevas y analizándolas automáticamente. Nunca tienes que subir nada a mano.",
    "help.alarms.p2": "Las partidas nuevas se recogen aproximadamente una vez por hora por cada cuenta vinculada, y el análisis se ejecuta en segundo plano, así que normalmente puedes revisar una partida pocos minutos después de terminarla.",
    "help.alarms.p3": "Una vez analizada la partida, cada jugada que hiciste se compara con tus criterios de práctica. La jugada que coincide se llama alarma, y te la enviamos por correo y por notificación push.",
    "help.alarms.p4": "Tus criterios deciden por completo qué jugadas te llegan:",
    "help.alarms.p5": "Con Pro también puedes ajustar los criterios al detalle: un rango de número de jugada, un mínimo de puntos perdidos, cuánto tiempo pensaste la jugada, qué ritmos de juego cuentan y si un error repetido siempre debe avisarte.",
    "help.alarms.p6": "Las alarmas se agrupan en sesiones. Una sesión permanece abierta 30 minutos, y cada alarma nueva la prolonga otros 30 minutos.",
    "help.alarms.p7": "Por eso una tanda larga de partidas rara vez se convierte en una avalancha de notificaciones.",
    "help.alarms.p8": "La práctica de Errores del motor se construye exactamente con los mismos criterios que tus alarmas. Ampliar las categorías o el periodo de búsqueda te da más notificaciones y también una cola de práctica más grande; restringirlos hace que ambas cosas sean más selectivas.",
    "help.alarms.teaser": "Cómo se analizan tus partidas automáticamente y cuándo te avisamos.",
    "help.alarms.tip_wizard": "Si nunca has terminado el asistente de criterios de práctica, no se genera ninguna alarma. Completarlo una vez las activa.",
    "help.alarms.title": "Análisis, cuentas vinculadas y alarmas",
    "help.analytics.b_m_acpl": "Pérdida media de CP: consulta el glosario más abajo. Cuanto más baja, mejor.",
    "help.analytics.b_m_comeback": "Remontadas: partidas que ganaste después de estar en −3 o peor.",
    "help.analytics.b_m_exchange": "Errores de cambios: cambios que dejaron tu posición peor.",
    "help.analytics.b_m_forced": "Respuesta difícil forzada al rival: con qué frecuencia tu jugada dejó a tu rival una única respuesta estrecha.",
    "help.analytics.b_m_longthink": "Pensar mucho con varias opciones buenas: con qué frecuencia gastaste tiempo en posiciones donde varias jugadas valían.",
    "help.analytics.b_m_ontime": "Porcentaje de partidas perdidas por tiempo.",
    "help.analytics.b_m_ontime_winning": "Perdidas por tiempo estando ganando: caídas de bandera con la posición claramente a tu favor.",
    "help.analytics.b_m_pawn": "Errores de estructura de peones: errores estratégicos con estructuras de peones débiles.",
    "help.analytics.b_m_slipped": "Partidas con una ventaja de +3 desperdiciada: posiciones ganadoras que acabaron en derrota.",
    "help.analytics.b_m_streak": "Racha de jugadas más larga: tu serie más larga de jugadas de libro, brillantes, magníficas o mejores.",
    "help.analytics.b_m_tempos": "Tiempos perdidos de media por partida, por un desarrollo y un orden de jugadas ineficientes.",
    "help.analytics.b_m_wontime_lost": "Ganadas por tiempo estando completamente perdido: la imagen inversa, por honestidad.",
    "help.analytics.b_p_equal": "Igual o mejor hasta: el número de jugada hasta el que todavía no estabas perdiendo, tomado como valor intermedio de la semana. Es la métrica que revela si tus aperturas aguantan.",
    "help.analytics.b_p_precision": "Precisión: cuánto se acercaron tus jugadas a las del motor, promediado en las partidas de la semana. Consulta el glosario.",
    "help.analytics.b_p_rating": "Elo: tu puntuación al final de cada semana. La medida más directa, y también la más ruidosa.",
    "help.analytics.b_p_time": "Partidas con ventaja de tiempo: la proporción de partidas en las que mantuviste más tiempo en el reloj que tu rival durante la mayor parte del juego.",
    "help.analytics.b_p_winshare": "Cuota de ventaja: el porcentaje de tus propias jugadas tras las cuales estabas al menos un tercio de peón mejor. Mide cuánta parte de tus partidas pasas por delante, no cómo terminaron.",
    "help.analytics.cta_analytics": "Abrir analíticas",
    "help.analytics.g_acpl_def": "Por cada jugada tuya, cuántos centipeones cedió esa jugada frente a la mejor, promediado luego entre todas tus jugadas. Las jugadas buenas cuentan como cero en vez de compensar los errores, así que el número solo mide el daño. Por debajo de 50 es juego fuerte; por encima de 100 apunta a errores reales.",
    "help.analytics.g_acpl_term": "Pérdida media de CP",
    "help.analytics.g_cp_def": "Una centésima de peón. Es la unidad con la que los motores puntúan una posición: +50 cp significa que estás medio peón mejor, algo que puede venir de una ventaja de espacio o actividad y no de material real.",
    "help.analytics.g_cp_term": "Centipeón (cp)",
    "help.analytics.g_fen_def": "Notación Forsyth-Edwards: una línea de texto que describe una única posición, con dónde están las piezas, a quién le toca mover y los derechos de enroque y de captura al paso. ChessWiz la usa como identidad de una posición, y así un favorito guardado o una explicación de la IA quedan ligados a un tablero concreto.",
    "help.analytics.g_fen_term": "FEN",
    "help.analytics.g_pgn_def": "Notación Portable Game: el formato de texto estándar para una partida entera, con los jugadores, el evento, el resultado y la lista completa de jugadas. Es lo que se importa cuando se sincronizan tus partidas.",
    "help.analytics.g_pgn_term": "PGN",
    "help.analytics.g_precision_def": "La misma información que la pérdida media de CP, expresada como una puntuación de 0 a 100%. Se escala entre dos referencias: un juego que pierde unos 0,05 peones por jugada se acerca al 100%, y uno que pierde unos 2,2 peones por jugada se acerca al 0%.",
    "help.analytics.g_precision_term": "Precisión",
    "help.analytics.g_streak_def": "La serie más larga de jugadas consecutivas que el motor calificó como de libro, mejor, magnífica o brillante.",
    "help.analytics.g_streak_term": "Racha de mejores jugadas",
    "help.analytics.h_glossary": "Términos de ajedrez usados en la app",
    "help.analytics.h_progress": "Progreso: ¿estás mejorando?",
    "help.analytics.h_strategic": "Analíticas estratégicas",
    "help.analytics.p1": "Las analíticas responden a dos preguntas distintas. Las Analíticas estratégicas preguntan qué sigue saliendo mal; Progreso pregunta si estás mejorando. Conviene leerlas en ese orden.",
    "help.analytics.p2": "Esta pantalla agrupa tus debilidades recurrentes en cuatro familias —seguridad del rey, estructura de peones, actividad de piezas y principios generales— dentro de una ventana de tus partidas recientes. La ventana es de un mes en el plan gratuito y de hasta seis meses con Pro.",
    "help.analytics.p3": "Puedes ver esos patrones de dos formas. Ocurrencias cuenta cuántas veces aparece un patrón. Impacto puntúa de 0% a 100% cuánto te cuesta de verdad, combinando lo dañinas que fueron las jugadas con la intensidad del patrón. Un patrón puede ser frecuente y barato, o raro y carísimo: el impacto es lo que los distingue.",
    "help.analytics.p4": "Debajo hay una cuadrícula de métricas estratégicas y de tiempo, que puedes leer como totales o semana a semana:",
    "help.analytics.p5": "Progreso agrupa tus partidas por semanas y sigue unas cuantas métricas de resultado. Cada una responde a una pregunta distinta sobre tu juego:",
    "help.analytics.p6": "Junto a todo eso, una tarjeta de actividad registra lo que has estado haciendo de verdad: tu racha de entrenamiento diario, puzles resueltos, partidas revisadas, alarmas recibidas y un desglose de los tipos de práctica que usas. El plan gratuito ve las últimas semanas; Pro ve todo el histórico.",
    "help.analytics.teaser": "Patrones estratégicos, tu progreso en el tiempo y los términos de ajedrez detrás de todo ello.",
    "help.analytics.title": "Analíticas",
    "help.contact.body_diagnostics": "Datos de la app",
    "help.contact.body_intro": "Describe aquí tu pregunta o problema:",
    "help.contact.cta": "Contáctanos",
    "help.contact.mail_failed": "Escríbenos a {email}",
    "help.contact.subject": "Soporte de ChessWiz",
    "help.contact.subject_with_topic": "Soporte de ChessWiz — {topic}",
    "help.contact.subtitle": "Leemos todos los mensajes. Cuéntanos qué estabas intentando hacer y te ayudamos.",
    "help.contact.title": "¿Te queda alguna duda?",
    "help.index.intro": "Guías breves sobre cómo funciona ChessWiz y cómo sacarle el máximo partido.",
    "help.notifications.b_accept": "Aceptar añade la línea a tu práctica de aperturas para que aparezca en tus ejercicios.",
    "help.notifications.b_godeeper": "Profundizar: la línea va más allá de la profundidad que ya dominas, así que amplía tu repertorio una jugada.",
    "help.notifications.b_pointslost": "Puntos perdidos: cuánto te costó el desliz en la partida de la que proviene.",
    "help.notifications.b_recent": "Apariciones recientes: cuántas veces surgió esta posición exacta en tus partidas recientes.",
    "help.notifications.b_skip": "Saltar archiva la sugerencia.",
    "help.notifications.h_actions": "Aceptar y Saltar",
    "help.notifications.h_review": "Revisar la línea",
    "help.notifications.h_why": "Por qué ves una línea",
    "help.notifications.p1": "Cuando una de tus aperturas favoritas revela un error recurrente o una oportunidad de aprender la siguiente jugada, ChessWiz deja una sugerencia en tus Notificaciones, agrupada en \"Notificaciones de práctica de aperturas\".",
    "help.notifications.p_review": "El tablero es una revisión de solo lectura: recorre toda la línea con los controles de primera/atrás/adelante/última o toca una ficha de jugada. En la jugada final, la flecha verde es la jugada de libro que debes aprender y la roja es la que jugaste en su lugar.",
    "help.notifications.p_why": "Cada tarjeta se explica sola para que sepas que vale tu tiempo:",
    "help.notifications.teaser": "Sugerencias semanales para \"profundizar\" a partir de tus propios errores de apertura, y qué hacen Aceptar y Saltar.",
    "help.notifications.tip_30days": "Las líneas saltadas no se vuelven a sugerir durante 30 días; si el error sigue ocurriendo después, puede volver.",
    "help.notifications.title": "Notificaciones de práctica de aperturas",
    "help.openings.b_cleandepth": "Profundidad limpia: el número de jugada promedio hasta el que fuiste preciso antes del primer error. Cuanto más profunda, mejor, y es lo que vigila el control de retrocesos.",
    "help.openings.b_firstslow": "Tiempo hasta la primera reflexión larga: la jugada de apertura más temprana en la que tardaste más que tu umbral de reflexión. Una jugada más tardía significa que estás recordando tu preparación en lugar de calcularla en el tablero.",
    "help.openings.b_offbook": "Rival se sale del libro primero: el porcentaje de partidas en las que tu rival abandonó el top 3 del motor antes que tú. Cuando es alto, sueles ser tú quien sigue en el libro, así que ganas la batalla de la apertura más a menudo.",
    "help.openings.b_reoccurrence": "Repeticiones: con qué frecuencia apareció la misma línea en tus partidas esa semana. Las líneas que más repites son las primeras que conviene pulir.",
    "help.openings.b_streak": "Racha en el top-3 del motor: cuántas de tus jugadas de apertura seguidas (hasta la jugada 15) se mantuvieron entre las tres mejores opciones del motor antes de tu primer desliz. Cuanto más alta, más lejos seguiste tu libro.",
    "help.openings.cta_analytics": "Abrir analíticas de aperturas",
    "help.openings.cta_settings": "Ajustar tu umbral de reflexión",
    "help.openings.h_favorites": "Sigue tus favoritas",
    "help.openings.h_metrics": "Qué significa cada número",
    "help.openings.h_recs": "Sugerencias de práctica",
    "help.openings.h_regressions": "Retrocesos",
    "help.openings.p1": "Las analíticas de aperturas miden lo bien que juegas la apertura en las líneas que más te importan. Solo tienen en cuenta tus aperturas favoritas y convierten cada semana de partidas en un pequeño conjunto de cifras cuya tendencia puedes seguir con el tiempo.",
    "help.openings.p2": "Cada apertura que marcas como favorita en Práctica se convierte aquí en una línea seguida, separada por el color con el que la juegas. Marca algunas líneas y dales una semana de partidas: los gráficos se irán completando a medida que se analicen partidas nuevas.",
    "help.openings.p3": "Cada línea favorita tiene una tarjeta y una línea de tiempo semanal construidas a partir de estas métricas:",
    "help.openings.p4": "Cuando la profundidad limpia de una línea esta semana cae por debajo de la que ya habías alcanzado antes, la marcamos como retroceso: señal de que un error empieza a aparecer antes que de costumbre. Estas líneas se muestran primero en \"Requiere atención\" para que sepas qué repasar.",
    "help.openings.p5": "Cuando notamos que te sales del libro en una partida real, convertimos ese momento en una línea de práctica lista para usar y la dejamos en tu bandeja de notificaciones. Tu informe semanal también te recuerda cuántas líneas de apertura están esperando revisión.",
    "help.openings.teaser": "Qué significan los gráficos de racha del motor, salida del libro y tiempo de reflexión en tus líneas favoritas.",
    "help.openings.tip_threshold": "El umbral de reflexión se ajusta en Ajustes. Su valor por defecto depende de tu elo; bájalo si eres un jugador más fuerte o súbelo si quieres más margen.",
    "help.openings.title": "Analíticas de aperturas",
    "help.plans.cta_subscription": "Ver planes y mejorar",
    "help.plans.free_alarms": "Sesiones de alarmas ilimitadas.",
    "help.plans.free_askai": "Una explicación de Pregunta a la IA al día.",
    "help.plans.free_history": "Hasta 2 meses de historial importado y hasta 100 partidas por importación.",
    "help.plans.free_lookback": "La práctica y la revisión abarcan los últimos 7 días.",
    "help.plans.free_puzzles": "Los puzles estratégicos seleccionados se desbloquean en orden: necesitas resolver el 70% de un nivel de dificultad antes de que se abra el siguiente.",
    "help.plans.free_sites": "Una cuenta de ajedrez vinculada.",
    "help.plans.h_free": "Gratis",
    "help.plans.h_pro": "Pro",
    "help.plans.p1": "ChessWiz tiene dos planes: Gratis y Pro. Todo lo que aparece abajo lo aplica la app de verdad, así que es exactamente lo que cambia al mejorar tu plan.",
    "help.plans.pro_alarms": "Sesiones de alarmas ilimitadas: te llega toda sesión que coincida con tus criterios.",
    "help.plans.pro_askai": "Explicaciones de Pregunta a la IA ilimitadas.",
    "help.plans.pro_finetune": "Controles de ajuste fino para tus criterios de práctica: rango de jugadas, puntos perdidos, tiempo empleado y ritmos de juego.",
    "help.plans.pro_history": "Hasta 12 meses de historial y hasta 1000 partidas por importación.",
    "help.plans.pro_lookback": "La práctica y la revisión abarcan hasta 180 días, y tú eliges el periodo.",
    "help.plans.pro_puzzles": "Todos los niveles de dificultad de los puzles seleccionados están abiertos desde el principio.",
    "help.plans.pro_sites": "Hasta 4 cuentas de ajedrez vinculadas.",
    "help.plans.teaser": "Qué incluye el plan gratuito y qué cambia con Pro.",
    "help.plans.tip_data": "Tus cuentas vinculadas, tus favoritos y tu historial se quedan donde están al cambiar de plan. Mejorar el plan amplía los límites; no reinicia nada.",
    "help.plans.title": "Planes de suscripción",
    "help.practices.b_daily_alarm": "Tus flashcards de errores recurrentes van siempre al final.",
    "help.practices.b_daily_anchor": "Los errores del motor, las aperturas y la revisión de tus alarmas se incluyen siempre que tengan contenido.",
    "help.practices.b_daily_mix": "Las tareas combinan los tipos de práctica de arriba, y las opcionales rotan de un día a otro para que no te toque siempre la misma tanda.",
    "help.practices.b_daily_size": "La tanda tiene entre cuatro y ocho tareas según cuánto hayas jugado: más partidas, más tareas.",
    "help.practices.b_engine_mistakes": "Errores del motor: una cola con tus propias jugadas marcadas, seleccionadas según tus criterios de práctica.",
    "help.practices.b_engine_rush": "Engine Rush: retoma uno de tus medios juegos y sigue encontrando jugadas aprobadas por el motor.",
    "help.practices.b_favorites": "Favoritos: las posiciones que marcaste como dignas de recordar.",
    "help.practices.b_good_decision": "¿Buena decisión?: decide si una elección estratégica que hiciste fue acertada.",
    "help.practices.b_guess_eval": "Adivina la evaluación: juzga quién está mejor y por cuánto, y compáralo con el motor.",
    "help.practices.b_move_verdict": "Puzles flashcard: una posición y una sola jugada; desliza para decir si era la mejor jugada.",
    "help.practices.b_rush": "Puzzle Rush: resuelve todas las que puedas antes de que se agoten los tres minutos.",
    "help.practices.b_streak": "Racha de puzles: resuelve posiciones de tus partidas una tras otra; un fallo termina la racha.",
    "help.practices.b_worst_move": "Encuentra la peor jugada: localiza la peor jugada entre las candidatas y encadena una racha.",
    "help.practices.b_worst_piece": "¿Peor pieza?: identifica tu pieza peor colocada en una posición de una de tus partidas.",
    "help.practices.cta_daily": "Abrir el entrenamiento diario",
    "help.practices.cta_practice": "Ver todos los modos de práctica",
    "help.practices.h_daily": "Entrenamiento diario",
    "help.practices.h_notyours": "No sale de tus partidas",
    "help.practices.h_yourgames": "Creado a partir de tus partidas",
    "help.practices.p1": "La mayoría de las apps de ajedrez te dan puzles de una base de datos común. ChessWiz hace casi lo contrario: tu práctica se construye con posiciones que alcanzaste de verdad y errores que cometiste de verdad. Por eso la misma idea vuelve una y otra vez: es un hábito tuyo, no un puzle al azar.",
    "help.practices.p2": "La Práctica de aperturas juega líneas de un catálogo de aperturas estándar, pero pone primero las familias y líneas que tú juegas de verdad, y resalta las jugadas en las que ya te has equivocado antes.",
    "help.practices.p3": "Los Puzles estratégicos seleccionados son una biblioteca revisada por personas y organizada por tema estratégico y dificultad. Es el único modo que no se basa en tus propias partidas.",
    "help.practices.p4": "El entrenamiento diario es una tanda breve que se crea cada día a partir de las partidas que jugaste el día anterior, una vez analizadas.",
    "help.practices.p5": "Terminar todas las tareas completa el día y alarga tu racha. Saltarte una tarea deja el día abierto. Cada día se crea una tanda nueva, así que no hay nada que reiniciar.",
    "help.practices.teaser": "Puzles creados a partir de tus propias partidas, además de tu entrenamiento diario.",
    "help.practices.title": "Práctica",
    "help.review.b_arrows": "Las tres mejores continuaciones del motor se dibujan como flechas numeradas del 1 al 3. Cuando ya hay en el tablero una flecha verde de «deberías haber jugado esto», las flechas numeradas pasan a ámbar para que nunca se confundan.",
    "help.review.b_askai_anchor": "La pregunta se ancla a la posición justo antes de tu jugada, así que la respuesta trata de la jugada que se te escapó, no de la respuesta de tu rival.",
    "help.review.b_askai_limit": "Está disponible hasta la jugada 30. En el plan gratuito tienes una explicación al día; con Pro son ilimitadas.",
    "help.review.b_askai_when": "Aparece en tus propias imprecisiones, errores, errores garrafales y mates perdidos, mientras recorres la partida y no en el análisis del motor.",
    "help.review.b_categories": "Cada jugada recibe una nota: brillante, magnífica, mejor, excelente, buena, de libro, imprecisión, error, error garrafal o mate perdido. Un mate perdido no es lo mismo que un error garrafal: significa que dejaste escapar una ventaja decisiva o un mate forzado, no que perdieras la posición.",
    "help.review.b_evalbar": "La barra de evaluación indica quién está mejor. Desde el menú Más puedes añadir también una barra horizontal.",
    "help.review.b_g_clock": "Toca la ficha del reloj para ir directamente a la línea de tiempos de la partida.",
    "help.review.b_g_longpress_arrows": "Mantén pulsadas las flechas de navegación para avanzar rápido por las jugadas en vez de tocar una y otra vez.",
    "help.review.b_g_longpress_piece": "Mantén pulsada cualquier pieza del tablero para abrir su ficha: si está activa o pasiva y por qué, los tiempos perdidos y, en el caso de los peones, si está pasado, retrasado, aislado, doblado o colgando.",
    "help.review.b_g_swipe_down": "Desliza hacia abajo, ya con la pantalla arriba del todo, para volver a la lista de partidas.",
    "help.review.b_g_swipe_games": "Desliza a izquierda y derecha cuando no estés analizando para ir a la partida anterior o siguiente de tu lista.",
    "help.review.b_g_swipe_panels": "Desliza a izquierda y derecha durante el análisis para recorrer los paneles: motor, resumen, piezas, jugada, planes y conceptos. Si te pasas de cualquiera de los extremos, sales del análisis.",
    "help.review.b_g_tap_piece": "Toca una pieza mientras solo estás repasando la partida para saltar directamente al análisis del motor.",
    "help.review.b_precision": "Cada jugador recibe un porcentaje de precisión de la partida, junto con la pérdida media de centipeones.",
    "help.review.cta_games": "Abrir tus partidas",
    "help.review.h_askai": "Pregunta a la IA",
    "help.review.h_coach": "El entrenador",
    "help.review.h_engine": "Qué te muestra el motor",
    "help.review.h_favorites": "Favoritos, notas y aperturas",
    "help.review.h_gestures": "Gestos que conviene conocer",
    "help.review.h_strategic": "Conceptos y motivos estratégicos",
    "help.review.p1": "Abrir una de tus partidas te da mucho más que una línea del motor. En la misma pantalla están el motor, un entrenador que explica la posición con palabras, los conceptos estratégicos detrás de cada jugada y una forma de guardar todo lo que merezca la pena revisitar.",
    "help.review.p2": "La bombilla junto al recuento de material activa el entrenador. Al tocarla vas pasando por un resumen de la posición, una explicación de la jugada que acabas de hacer y después un estado silenciado; un toque más y vuelve a apagarse.",
    "help.review.p3": "La bombilla parpadea y mantiene un punto pequeño siempre que la jugada en la que estás tiene algo que comentar, así puedes recorrer la partida y detenerte solo donde importa.",
    "help.review.p4": "Más allá de la evaluación, cada jugada se compara en términos estratégicos: qué mejoró y qué empeoró, agrupado en seguridad del rey, estructura de peones, actividad de piezas y principios generales. Las contrapartidas aparecen como ambas cosas a la vez: mejoraste algo y estropeaste otra cosa.",
    "help.review.p5": "Pregunta a la IA convierte uno de tus errores en algo que puedas recordar de verdad: una frase gancho corta más una o dos líneas que explican por qué la jugada mejor era mejor. Es una ayuda para memorizar esa posición, no un chat.",
    "help.review.p6": "La estrella guarda la posición actual como un puzle para practicar más adelante. Siempre guarda la posición en la que te toca mover, así que si estás mirando tu propia jugada retrocede medio movimiento por ti. Funciona en cualquier jugada, no solo en los errores.",
    "help.review.teaser": "El entrenador, Pregunta a la IA, los conceptos estratégicos y los gestos menos evidentes.",
    "help.review.tip_longpress_star": "Mantén pulsada la estrella en lugar de tocarla y podrás elegir: guardarla como favorita con una nota, o almacenar la línea como apertura para practicar. Las notas son opcionales y admiten hasta 200 caracteres.",
    "help.review.tip_squares": "Cuando una observación menciona una casilla, esa casilla es un botón que puedes tocar: entonces parpadea en ámbar sobre el tablero, para que veas de qué está hablando la frase.",
    "help.review.title": "Revisión de partidas",
    "help.screen_title": "Ayuda"
  }
};
